module.exports = __webpack_public_path__ + "img/image29.689c5352.png";